import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UsersCountSlice = createSlice({
    name: "usersCount",
    initialState,
    reducers: {
        usersCountRequest(state) {
            state.loading = true;
        },
        usersCountRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        usersCountRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    usersCountRequest,
    usersCountRequestSuccess,
    usersCountRequestError,
} = UsersCountSlice.actions;

export default UsersCountSlice.reducer;
